module.exports = " <section class=row> <div class=col-xs-12> <table class=\"table table-striped\" v-if=items.length> <thead> <tr> <th>&nbsp;</th> <th>Next Pickup</th> <th># Related Orders</th> <th>Total Weight</th> </tr> </thead> <tbody> <tr v-for=\"item in items\" :item=item is=item-group track-by=product.id></tr> </tbody> </table> <div v-if=!items.length class=\"text-center no-orders\"> <img src=" + require("../../assets/images/logo-sm.svg") + " /><br/> There are no items to group process. </div> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/ItemGroups.vue
// module id = 375
// module chunks = 2